import './index.css'

interface BreadcrumbsProps {
  pathlist?: any[]
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ pathlist = [] }) => {

  const paths = pathlist.length - 1

  return (
    <div className="breadcrumbs-nav">
      {
        pathlist.map((item, index) => (
          <div key={index} className={`breadcrumbs-nav__item ${index === paths ? 'last' : ''}`}>
            {item} <span className="breadcrumbs-nav__sep">{index < paths ? '/' : ''}</span>
          </div>

        ))
      }
    </div>

  )

}

export default Breadcrumbs